import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.concat.js";
import { BaseTransformer } from './BaseTransformer';
export var CrmContactTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(CrmContactTransformer, _BaseTransformer);
  var _super = _createSuper(CrmContactTransformer);
  function CrmContactTransformer() {
    _classCallCheck(this, CrmContactTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(CrmContactTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        recordId: data.record_id,
        accountName: {
          value: data.account_name ? data.account_name.value : null,
          label: data.account_name ? data.account_name.label : null
        },
        fullName: data.fullname ? data.fullname : "".concat(data.firstname, " ").concat(data.lastname),
        firstname: data.firstname,
        lastname: data.lastname,
        title: data.job_title,
        mobile: data.mobile,
        phone: data.phone,
        email: data.email,
        profile_photo: data.profile_photo,
        emailOptIn: data.email_opt_in ? true : false,
        smsOptIn: data.sms_opt_in ? true : false,
        customerPortalUser: data.customer_portal_user ? true : false,
        portalProfile: data.portal_profile,
        PrivacyOptIn: data.privacy_opt_in ? true : false,
        CallOptIn: data.call_opt_in ? true : false,
        secondaryEmail: data.secondary_email,
        linkedin: data.linkedin,
        twitter: data.twitter,
        facebook: data.facebook,
        instagram: data.instagram,
        isPrimary: data.is_primary ? true : false,
        contactStatus: data.contact_status
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      // if(data.recordId==null){
      //   data.recordId = 0
      // }
      return {
        record_id: data.recordId,
        account_name: data.accountName && data.accountName.value,
        fullname: data.fullName,
        firstname: data.firstname,
        lastname: data.lastname,
        profile_photo: data.profile_photo,
        job_title: data.title,
        mobile: data.mobile,
        phone: data.phone,
        email: data.email,
        email_opt_in: data.emailOptIn,
        is_primary: data.isPrimary,
        sms_opt_in: data.smsOptIn,
        customer_portal_user: data.customerPortalUser ? true : false,
        portal_profile: data.portalProfile && data.portalProfile.value,
        privacy_opt_in: data.PrivacyOptIn ? true : false,
        call_opt_in: data.CallOptIn ? true : false,
        linkedin: data.linkedin,
        twitter: data.twitter,
        facebook: data.facebook,
        instagram: data.instagram,
        contact_status: data.contactStatus && data.contactStatus.value
      };
    }
  }]);
  return CrmContactTransformer;
}(BaseTransformer);